import { FC, ReactElement } from 'react'

interface JourneyType {
  switchElement?: ReactElement
}

export const JourneyType: FC<JourneyType> = ({ switchElement }) => {
  return <div className="gap-semantic-global-lg flex flex-col">{switchElement ? switchElement : null}</div>
}
